import script from "./LanguageTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageTabs.vue?vue&type=script&setup=true&lang=js"

import "./LanguageTabs.vue?vue&type=style&index=0&id=72765080&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72765080"]])

export default __exports__